class ProductBoxDiscovery extends HTMLElement {
  connectedCallback() {
    this.panels = this.querySelectorAll('[data-product-panel]');
    this.items = this.querySelectorAll('[data-product-trigger]');

    if (!this.panels.length || !this.items.length) return;

    this.items.forEach((item) => {
      const productId = item.dataset.productId;
      item.addEventListener('mouseenter', () => this.#activate(productId));
      item.addEventListener('focusin', () => this.#activate(productId));
    });
  }

  #activate(productId) {
    if (!productId) return;

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.productId === productId);
    });
  }
}

if (!customElements.get('product-box-discovery')) {
  customElements.define('product-box-discovery', ProductBoxDiscovery);
}
